import { EditableV2 } from "./Editable";
export default EditableV2;
